// Availability is independent of roles. Missing keys preserve existing tenants.
export function getProjectModuleAvailability(features = {}) {
  const permits = features?.permits !== false;
  const locates = features?.locates !== false;
  return { permits, locates, any: permits || locates,
    label: permits && locates ? 'Permits & Locates' : permits ? 'Permits' : locates ? 'Locates' : '' };
}

export function projectFieldModule(field) {
  if (field.startsWith('permit_')) return 'permits';
  if (field.startsWith('locate_') || field.startsWith('water_locate') || field === 'water_readiness' || field === 'current_trouble_count') return 'locates';
  return null;
}

export function isProjectColumnAvailable(field, features = {}) {
  const module = projectFieldModule(field);
  return !module || getProjectModuleAvailability(features)[module];
}

export function omitDisabledProjectFields(document, features = {}) {
  return Object.fromEntries(Object.entries(document).filter(([field]) => isProjectColumnAvailable(field, features)));
}

export function projectRecordModule(record) {
  const value = String(record?.permit_type || '').toLowerCase();
  const permit = value.includes('permit'), locate = value.includes('locate');
  return permit === locate ? null : locate ? 'locates' : 'permits';
}

export function isProjectRecordAvailable(record, features = {}) {
  const module = projectRecordModule(record);
  const modules = getProjectModuleAvailability(features);
  return module ? modules[module] : modules.permits && modules.locates;
}
